
const Button = ({
  btnText,
  btnColor,
  padding,
  btnBgColor,
  onClick,
  className,
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      className={`font-semibold  rounded-md ${btnBgColor} ${padding} ${btnColor} ${className}`}
      {...props}
    >
      {btnText}
    </button>
  );
};

export default Button;
